import { TaskId } from '/imports/domain';
import { end, formatRoute, lit, type, url } from '/imports/modules/Routing';

const ltiRoute = url(lit('lti'), type('taskId', TaskId), end);

export const ltiConsumerRoute = url(lit('lticonsumer'), end);

export const ltiLink = formatRoute(ltiRoute);
